<ng-select
  [items]="allSwitchSlots"
  [clearable]="false"
  bindLabel="title"
  bindValue="value"
  [formControl]="switchSlot"
  placeholder=""
></ng-select>
